import React, { cloneElement, Children } from 'react';
import { useController } from 'react-hook-form';

export default function RFG(props) {
  const { children, label, name } = props;
  const { field, fieldState } = useController(props);

  return (<>
    <label className="input-label" style={props?.labelStyle}>{label}</label>
    <div className="mb-3">

      {Children.map(children, child =>
        cloneElement(child, {
          id: name,
          placeholder: label,
          ...field,
          // Remove existing `value` and `onChange` props to avoid conflicts
          value: field.value || '',
        })
      )}
      <div className="error mb-2 text-red-500 text-sm">
        {fieldState?.error?.type === 'required' && `${name} is required`}
        {fieldState?.error?.message}
      </div>
    </div>
  </>
  );
}
